import "@lit-labs/ssr-client/lit-element-hydrate-support.js";

const path = window.location.pathname;

if (path === "/") {
  import("./sub-pages/home.js");
} else if (path.includes("about-us")) {
  import("./components/team-member.js");
  import("./sub-pages/about-us.js");
} else if (path.includes("our-services")) {
  import("./sub-pages/our-services.js");
} else if (path.includes("contact-us")) {
  import("altcha");
  import("./sub-pages/contact-us.js");
} else if (path.includes("articles")) {
  const pattern = /articles\/([a-zA-Z0-9]+)$/;
  const isMatch = pattern.test(path);
  if (isMatch) {
    import("altcha");
    import("./sub-pages/article.js");
  } else {
    import("./sub-pages/articles.js");
  }
}
document.body.removeAttribute("dsd-pending");
